const extractPhoneNumberFromText = (text) => {

    let phone = '';
    const regexPattern = /\(?\b\s?\+?([0-9-.+( ))]{7,18})/g;
    const matches = text.match(regexPattern);
    if (!matches) {
        return;
    }
    for (let i = 0; i < matches.length; i++) {
        phone = matches[i].replace(/[{}]/g, '');
    }
    return phone.replace(/[^\d\+x]/g, '');
};
export default extractPhoneNumberFromText;
